const PortfolioContainer = ({ PortfolioData, openDetail }) => {
    const { id, title, description, type, technologies } = PortfolioData;

    return (
        <div
            onClick={openDetail(id)}
            className="group relative overflow-hidden rounded-2xl cursor-pointer transition-all duration-300"
            style={{
                background: "rgba(255,255,255,0.03)",
                border: "1px solid rgba(255,255,255,0.07)",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(200,151,42,0.05)";
                e.currentTarget.style.borderColor = "rgba(200,151,42,0.25)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(255,255,255,0.03)";
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.07)";
            }}
        >
            {/* Gold top accent line on hover */}
            <div
                className="absolute top-0 left-0 right-0 h-[1px] opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{
                    background: "linear-gradient(90deg, transparent, #C8972A, transparent)",
                }}
            />

            <div className="p-5">
                {/* Type badge */}
                <span
                    className="inline-block mb-3"
                    style={{
                        fontSize: "10px",
                        fontWeight: 600,
                        letterSpacing: "0.08em",
                        textTransform: "uppercase",
                        padding: "3px 10px",
                        borderRadius: "4px",
                        background: "rgba(200,151,42,0.1)",
                        border: "1px solid rgba(200,151,42,0.2)",
                        color: "rgba(200,151,42,0.85)",
                    }}
                >
                    {type}
                </span>

                {/* Title */}
                <h3
                    className="font-bold text-white mb-2 transition-colors duration-200 group-hover:text-[#C8972A]"
                    style={{ fontSize: "15px", letterSpacing: "-0.01em" }}
                >
                    {title}
                </h3>

                {/* Description */}
                <p
                    className="leading-relaxed line-clamp-2"
                    style={{ fontSize: "12px", color: "rgba(255,255,255,0.45)" }}
                >
                    {description}
                </p>

                {/* Tech stack preview */}
                {technologies && technologies.length > 0 && (
                    <div className="flex flex-wrap gap-1.5 mt-4">
                        {technologies.slice(0, 3).map((tech) => (
                            <span
                                key={tech.id}
                                style={{
                                    fontSize: "10px",
                                    padding: "2px 7px",
                                    borderRadius: "3px",
                                    background: "rgba(255,255,255,0.06)",
                                    border: "1px solid rgba(255,255,255,0.1)",
                                    color: "rgba(255,255,255,0.5)",
                                }}
                            >
                                {tech.name}
                            </span>
                        ))}
                        {technologies.length > 3 && (
                            <span
                                style={{
                                    fontSize: "10px",
                                    padding: "2px 7px",
                                    borderRadius: "3px",
                                    color: "rgba(200,151,42,0.6)",
                                }}
                            >
                                +{technologies.length - 3} more
                            </span>
                        )}
                    </div>
                )}

                {/* View arrow */}
                <div
                    className="flex items-center gap-1 mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    style={{ fontSize: "11px", color: "#C8972A" }}
                >
                    <span>View Project</span>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default PortfolioContainer;
